export class QueryParam{
    key ;
    reference ;

}